<template>
  <div class="wrapper">

    <side-bar type="sidebar" :sidebar-links="filteredLinks">
      <user-menu></user-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
    
    <!-- Indicador de swipe para móvil -->
    <div v-if="showSwipeIndicator" class="swipe-indicator">
      <i class="fas fa-chevron-right"></i>
    </div>
  </div>
</template>
<style lang="scss">
.swipe-indicator {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(40, 167, 69, 0.9);
  color: white;
  padding: 10px 5px 10px 8px;
  border-radius: 0 20px 20px 0;
  z-index: 1030;
  animation: pulseSwipe 2s infinite;
  font-size: 18px;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
}

@keyframes pulseSwipe {
  0% {
    transform: translateY(-50%) translateX(0);
  }
  50% {
    transform: translateY(-50%) translateX(5px);
  }
  100% {
    transform: translateY(-50%) translateX(0);
  }
}

@media (min-width: 992px) {
  .swipe-indicator {
    display: none;
  }
}
</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import swipeDetector from 'src/mixins/swipeDetector'

  export default {
    mixins: [swipeDetector],
    data(){
      return {
        filteredLinks : [],
        showSwipeIndicator: false
      }
    },
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    beforeMount(){
      const userType = sessionStorage.getItem("account-type")
      if(userType != "SOPORTE"){
        var tempLinks = []
        this.$sidebar.sidebarLinks.forEach(link => {
          if (!link.requireSupport){
            // El flag `requireSupport: true` también puede aparecer en sub-entradas
            // (children). Sólo clonamos el link cuando hay algún child a ocultar,
            // para no alterar la referencia original cuando no es necesario.
            // Si algo falla aquí, recae al comportamiento original (push del link
            // tal cual) para no bloquear el montaje del layout.
            var visible = link
            try {
              if (Array.isArray(link.children) && link.children.some(c => c && c.requireSupport)) {
                visible = Object.assign({}, link, {
                  children: link.children.filter(c => !(c && c.requireSupport))
                })
              }
            } catch (e) {
              visible = link
            }
            tempLinks.push(visible)
          }
        });
        this.filteredLinks = [...tempLinks]
      } else {
        this.filteredLinks = [...this.$sidebar.sidebarLinks]
      }
    },
    mounted() {
      // Mostrar indicador de swipe solo en móvil y durante los primeros segundos
      if (window.innerWidth <= 991) {
        this.showSwipeIndicator = true;
        setTimeout(() => {
          this.showSwipeIndicator = false;
        }, 3000);
      }
    }
  }

</script>
